import { GetUnitHealthHistory } from '../types';

export const DISABLED_DATA_INFO: GetUnitHealthHistory = {
  MONTHLY_HISTORY: [
    {
      YEAR: 2025,
      MONTH: 1,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
    {
      YEAR: 2025,
      MONTH: 2,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
    {
      YEAR: 2025,
      MONTH: 3,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
    {
      YEAR: 2025,
      MONTH: 4,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
    {
      YEAR: 2025,
      MONTH: 5,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
    {
      YEAR: 2025,
      MONTH: 6,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
    {
      YEAR: 2025,
      MONTH: 7,
      PERCENTAGE_HEALTHY: 100,
      PERCENTAGE_ALERT: 0,
      PERCENTAGE_CRITICAL: 0,
      PERCENTAGE_INOPERANT: 0,
      COUNT_TOTAL_UNITS_HEALTHY: 0,
      COUNT_TOTAL_UNITS_ALERT: 0,
      COUNT_TOTAL_UNITS_CRITICAL: 0,
      COUNT_TOTAL_UNITS_INOPERANT: 0,
    },
  ],
};
